import apiClient from '@u/apiClient'
import GetInvoiceItemByIdController from '@/wayfinder/actions/App/Http/Controllers/InvoiceItem/GetInvoiceItemByIdController'
import GetThirdPartyCostListController from '@/wayfinder/actions/App/Http/Controllers/ThirdPartyCostPayment/GetThirdPartyCostListController'
import GetInvoiceItemsByThirdPartyCostPaymentIdController from '@/wayfinder/actions/App/Http/Controllers/ThirdPartyCostPayment/GetInvoiceItemsByThirdPartyCostPaymentIdController'
import GetPaymentByIdController from '@/wayfinder/actions/App/Http/Controllers/Payment/GetPaymentByIdController'
import GetInvoiceChiftPaymentsController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetInvoiceChiftPaymentsController'
import GetInvoicePaymentSyncHistoryController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetInvoicePaymentSyncHistoryController'
import GetPaymentByFactureIdController from '@/wayfinder/actions/App/Http/Controllers/Payment/GetPaymentByFactureIdController'
import LinkPaymentController from '@/wayfinder/actions/App/Http/Controllers/Invoice/LinkPaymentController'
import DeletePaymentController from '@/wayfinder/actions/App/Http/Controllers/Payment/DeletePaymentController'
import UnlinkPaymentController from '@/wayfinder/actions/App/Http/Controllers/Invoice/UnlinkPaymentController'
import { apiPath } from '@u/apiPath'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  fetchThirdPartyCostInvoiceItem(_ctx, { id, invoice_id }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetInvoiceItemByIdController.get({
            invoice: invoice_id,
            invoice_item: id
          })
        )
        .then((response) => {
          resolve(response.data.invoice_item)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchAllThirdPartyCost({ commit }, payload: Record<string, any> = {}) {
    const { filters = [], page = 1 } = payload
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetThirdPartyCostListController.get(), {
          params: {
            filters,
            paginate: 50,
            page
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchPaidInvoiceItemsByThirdPartyCostId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetInvoiceItemsByThirdPartyCostPaymentIdController.get({
            thirdPartyCostPayment: payload.thirdPartyCostId
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewThirdPartyPayment: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetNewModelController.get({
            query: { model: 'thirdPartyCostPayment' }
          })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  fetchPaymentById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPaymentByIdController.get({
            invoice: payload.invoice_id,
            payment: payload.payment_id
          })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  fetchInvoiceChiftPayments: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetInvoiceChiftPaymentsController.get({ invoice: payload.invoice_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchInvoicePaymentSyncHistory: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetInvoicePaymentSyncHistoryController.get({
            invoice: payload.invoice_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchPaymentsByInvoicingId: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPaymentByFactureIdController.get({ invoice: payload.invoice_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  linkPaymentToInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(LinkPaymentController.post({ invoice: payload.invoice_id }), {
          payment_id: payload.payment_id
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // region store
  storeNewThirdPartyCostPayment: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      let url = `third-party-cost-payment`
      apiClient
        .post(apiPath(url), payload)
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateThirdPartyCostPaymentById: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      let url = `third-party-cost-payment/${payload.id}`
      apiClient
        .put(apiPath(url), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region delete
  deletePayment: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeletePaymentController.delete.delete({
            invoice: payload.invoice_id,
            payment: payload.payment_id
          })
        )
        .then((response) => {
          commit('setInvoice', response.data.invoice)
          commit('setInvoiceMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  unlinkPayment: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UnlinkPaymentController.post({
            invoice: payload.invoice_id,
            payment: payload.payment_id
          }),
          {
            deletion_type: payload.deletion_type
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async undoDeletePayment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeletePaymentController.undo.get({
            invoice: payload.invoice_id,
            id: payload.payment_id
          })
        )
        .then((response) => {
          commit('setInvoice', response.data.invoice)
          commit('setInvoiceMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
